import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import maker from 'redux/maker';
import Section from 'components/molecules/Section';
import ImagesList from 'components/molecules/ImagesList';

const Makers = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const makers = useSelector(maker.selectors.selectAll);
  const loading = useSelector(maker.selectors.getLoadingState);

  useEffect(() => {
    dispatch(maker.thunks.fetch());
  }, [dispatch]);

  return (
    <Section title={t('makers')}>
      <ImagesList
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 2,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        dataSource={makers}
        loading={loading}
        baseUrl="/models?maker_id="
      />
    </Section>
  );
};

export default Makers;
